exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.totals-wrapper[data-v-5d9a0602] {\n  height: calc(80vh - 172px);\n  overflow: auto;\n}\n.input-group[data-v-5d9a0602] {\n  width: 35%;\n}\n.total-table-title[data-v-5d9a0602] {\n  white-space: nowrap;\n  font-size: 0.67rem;\n  font-weight: 500;\n  color: black;\n  text-align: right;\n}\n.mobile-only[data-v-5d9a0602] {\n  display: none;\n}\n@media screen and (max-width: 600px) {\n.mobile-only[data-v-5d9a0602] {\n    display: block;\n}\n.desktop-only[data-v-5d9a0602] {\n    display: none;\n}\n.new-bg[data-v-5d9a0602] {\n    height: 80vh !important;\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5d9a0602","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/reports/Discounts.vue
// module id = Yxlz
// module chunks = 0